import React from "react";

import { IIconType } from "components/shared/icon_types/_prop_interface";

function xIcon({ size, color, ...rest }: IIconType) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11.68 11.68"
      height={size}
      width={size}
      {...rest}
    >
      <path
        fill={color}
        d="M.697 11.157L11.157.697M1.285 11.755L.053 10.522 10.53.044l1.233 1.233z"
      />
      <g>
        <path
          fill={color}
          d="M11.157 11.157L.697.697M10.407 11.754L-.071 1.276 1.162.043 11.64 10.521z"
        />
      </g>
    </svg>
  );
}

export default xIcon;
